import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectOptionT } from '../../models/models';

export interface BrandsStateI {
    advertisersSO: SelectOptionT[];
    selectedBrand: SelectOptionT | null;
};

const initialState: BrandsStateI = {
    advertisersSO: [],
    selectedBrand: null,
};

const advertisersSlice = createSlice({
    name: 'advertisers',
    initialState,
    reducers: {
        setBrands: (state, action: PayloadAction<SelectOptionT[]>) => {
            state.advertisersSO = action.payload;
        },
        setSelectedBrands: (state, action: PayloadAction<SelectOptionT>) => {
            state.selectedBrand = action.payload;
        },
    },
});

export const {
    setBrands,
    setSelectedBrands,
} = advertisersSlice.actions;

export default advertisersSlice.reducer;